/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable, inject } from '@angular/core';
import {
  GetOutreachContextAPIResponse,
  PatchOutreachContextAPIRequest,
  PatchOutreachContextAPIResponse,
  PostOutreachContextAPIRequest,
  PostOutreachContextAPIResponse,
} from '@troyai/care-management/data-access';
import { RestApiClientService } from '@troyai/rest-api-client';

@Injectable({
  providedIn: 'root',
})
export class VoiceCallsApiService {
  private restApiService = inject(RestApiClientService);

  createCallContext(callContextId: string, payload: PostOutreachContextAPIRequest) {
    return this.restApiService.post<PostOutreachContextAPIResponse>(
      `cm/outreach/context/${callContextId}`,
      payload
    );
  }

  updateCallContext(callContextId: string, payload: PatchOutreachContextAPIRequest) {
    return this.restApiService.patch<PatchOutreachContextAPIResponse>(
      `cm/outreach/context/${callContextId}`,
      payload
    );
  }

  getCallContextByCallProviderId(providerCallId: string) {
    return this.restApiService.get<GetOutreachContextAPIResponse>(
      `cm/outreach/context/${providerCallId}`
    );
  }
}
